"use client";

import { ArrowRight } from "iconsax-reactjs";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { useRouter } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

export interface PageHeaderProps {
  title: ReactNode;
  onBack?: () => void;
  back?: boolean;
  actions?: ReactNode;
  className?: string;
}

export const PageHeader = ({
  title,
  onBack,
  back = true,
  actions,
  className,
}: PageHeaderProps) => {
  const router = useRouter();
  const showBack = back || !!onBack;
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {showBack && (
        <Button
          aria-label="back"
          className="p-0"
          variant="light"
          size="icon"
          onClick={onBack ?? (() => router.back())}
        >
          <ArrowRight size={20} />
        </Button>
      )}
      <h3 className="text-base font-semibold">{title}</h3>
      {actions ? (
        <div className="ms-auto flex items-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
};
